import { DIC } from "@/const/dic";

export const engineerOrderOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "300",
  labelWidth: "200",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    /* {
      label: "服务单编号",
      prop: "serveOrderNumber",
      formsolt: true,
    },
    {
      label: "二维码名称",
      prop: "qrcodeName",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
    }, */
    {
      label: "安装商品",
      search: true,
      prop: "goodsName",
      formsolt: true,
    },
    /* {
      label: "品牌",
      prop: "brandName",
      formsolt: true,
    },
    {
      label: "经销商",
      search: true,
      prop: "shopName",
      formsolt: true,
    }, */
    {
      label: "店铺名称",
      search: true,
      prop: "shopName",
      formsolt: true,
    },
    {
      label: "店铺电话",
      search: true,
      prop: "shopMobile",
      formsolt: true,
    },
    {
      label: "客户姓名",
      search: true,
      prop: "customName",
      type: "input",
    },
    {
      label: "客户电话",
      search: true,
      prop: "customMobile",
      type: "input",
    },
    {
      label: "项目地址",
      search: true,
      prop: "customAddress",
      type: "input",
      overHidden: true,
    },
    {
      label: "监理",
      search: true,
      prop: "engineeringSupervisorName",
      type: "input",
    },
    {
      label: "监理电话",
      search: true,
      prop: "engineeringSupervisorMobile",
      type: "input",
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      search: true,
      solt: true,
      addVisdiplay: false,
    },
    {
      label: "阶段状态",
      prop: "stageStatus",
      type: "select",
      search: true,
      hide: true,
      addVisdiplay: false,
      solt: true,
    },
    /* {
      label: "来源",
      prop: "source",
      type: "select",
      search: true,
      dicData: DIC.PRE_FILTER_SOURCE,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "安装时间",
      prop: "createTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    }, */
    /* {
      label: "开始时间",
      search: true,
      prop: "startTime",
      type: "datetime",
      hide: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "结束时间",
      search: true,
      prop: "endTime",
      type: "datetime",
      hide: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    }, */
  ],
};
